import styled from 'styled-components';

import { SMSVerification } from 'components/common/SMSVerification';
import { Popup } from 'components/uikit/Popup/Popup';

export const StyledPopup = styled(Popup)`
  min-width: 620px;
  max-width: 620px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Title = styled.h2`
  margin-bottom: 0px;

  font: var(--font-heading-large-28);
`;

export const Description = styled.p`
  margin-bottom: 0px;

  font: var(--font-regular-15);
`;

export const PhoneVerification = styled(SMSVerification)`
  height: 184px;
`;
